import axios from "axios";
import { baseURL } from "../config/api";

export const getTimeZones = (tenantId: string) => {
    return getFetch(`timezone`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}